<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg57"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs61"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath71"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path69" /></clipPath></defs><g
     id="g63"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g65"><g
         id="g67"
         clip-path="url(#clipPath71)"><g
           id="g73"
           transform="translate(455.6348,169.7422)"><path
             d="m 0,0 17.542,-139.751 c 1.499,-11.941 -7.81,-22.491 -19.844,-22.491 h -394.665 c -12.034,0 -21.344,10.55 -19.845,22.491 l 24.979,199 c 1.256,10.004 9.762,17.509 19.845,17.509 h 50.858"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path75" /></g><g
           id="g77"
           transform="translate(377.4966,246.5)"><path
             d="m 0,0 h 50.857 c 10.082,0 18.588,-7.505 19.844,-17.509 l 3.048,-24.282"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path79" /></g><g
           id="g81"
           transform="translate(107.6221,200.0103)"><path
             d="M 0,0 0.698,46.49"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path83" /></g><g
           id="g85"
           transform="translate(49.9902,119)"><path
             d="m 0,0 h 51.49 c 2.73,0 4.96,2.19 5,4.92 L 57.106,46"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path87" /></g><g
           id="g89"
           transform="translate(212,71)"><path
             d="M 0,0 H -168.03"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path91" /></g><g
           id="g93"
           transform="translate(348,7.5)"><path
             d="m 0,0 v 58.5 c 0,2.76 -2.24,5 -5,5 h -96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path95" /></g><g
           id="g97"
           transform="translate(468.0303,71)"><path
             d="m 0,0 h -65.03 c -2.76,0 -5,-2.24 -5,-5 v -58.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path99" /></g><g
           id="g101"
           transform="translate(276.9687,119)"><path
             d="M 0,0 H 185.041"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path103" /></g><g
           id="g105"
           transform="translate(158.3398,206.5)"><path
             d="m 0,0 -1.85,-82.42 c -0.04,-2.79 2.21,-5.08 5,-5.08 h 73.541"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path107" /></g><g
           id="g109"
           transform="translate(178.042,482.4912)"><path
             d="m 0,0 c 22.216,13.97 48.687,21.996 77.958,21.996 86.549,0 148.612,-70.162 148.612,-156.711 0,-120.61 -128.517,-231.085 -146.637,-245.099 -1.167,-0.903 -2.783,-0.903 -3.95,0 -18.12,14.014 -146.637,124.489 -146.637,245.099"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path111" /></g><g
           id="g113"
           transform="translate(107.3882,347.7764)"><path
             d="M 0,0 C 0,43.868 15.944,83.526 42.94,111.973"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path115" /></g><g
           id="g117"
           transform="translate(366,347.7866)"><path
             d="m 0,0 c 0,-60.751 -49.249,-110 -110,-110 -60.751,0 -110,49.249 -110,110 0,60.751 49.249,110 110,110 C -49.249,110 0,60.751 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path119" /></g></g></g></g></svg>
</template>
